import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import React, { useEffect, useState } from "react";

import { TabContext, TabList } from "@material-ui/lab";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { setTagType } from "services/api/communication";
import "../index.scss";

import SettingsRoutes from "./SettingsRoutes";
import "./tab.scss";

// /financial-setting?tab=<name> opens a tab directly (used by the global search bar);
// &section=twilio|preferences picks the Communications section
const TAB_FROM_URL = { organization: "1", financial: "2", members: "3", pastoral: "4", users: "5", communications: "6" };
const COMMUNICATION_SECTION_FROM_URL = { twilio: "twiliio", preferences: "communications" };

export default function SettingTab() {
	const [value, setValue] = React.useState("1");
	const [isUserManagementActive, setIsUserManagementActive] = useState(true);
	const [isPastoralEventsActive, setIsPastoralEventsActive] = useState(true);

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

	let orgInfo = localStorage?.getItem("authorizedModules")
		? JSON.parse(localStorage?.getItem("authorizedModules"))
		: [];

	useEffect(() => {
		setIsUserManagementActive(orgInfo?.find((item) => item?.moduleName === "user management")?.active);
		if (localStorage.getItem("openYahTemplate")) {
			setValue("8");
			localStorage.removeItem("openYahTemplate");
		}

		if (history.location.pathname.includes('/financial-setting/members')) {
			setValue("3");
		} else if (history.location.pathname.includes('/financial-setting/') && history.location.pathname.length > 19) {
			setValue("2");
		}
	}, []);

	// keep the highlighted tab in step with the URL, also when moving between Settings
	// pages without leaving Settings (e.g. from the global search bar)
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const tab = TAB_FROM_URL[params.get("tab")];
		if (tab) {
			setValue(tab);
			const section = COMMUNICATION_SECTION_FROM_URL[params.get("section")];
			if (tab === "6" && section) dispatch(setTagType(section));
		} else if (location.pathname.includes("/financial-setting/members")) {
			setValue("3");
		} else if (location.pathname.includes("/financial-setting/") && location.pathname.length > 19) {
			setValue("2");
		}
	}, [location.pathname, location.search]);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		history.push("/financial-setting");
	};
	const mainUrl = window.location.href.split("/");

	useEffect(() => {
		console.log("object")
		let check =
			orgInfo !== undefined ??
			orgInfo?.map((item) => {
				if (item?.moduleName == "events") {
					return setIsPastoralEventsActive(item?.active);
				}
			});
			setIsPastoralEventsActive(orgInfo?.find((item) => item?.moduleName === "pastoral")?.active);
	}, []);

	return (
		<>
			<Box className="tablist-main" sx={{ maxWidth: "100%", typography: "body1" }}>
				<TabContext value={value}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<TabList
							indicatorColor="primary"
							className="setting-tabs"
							onChange={handleChange}
							aria-label="lab API tabs example"

						>
							<Tab className=" setting-tabs-item" label="Organization info" value="1" style={{width: "150px"}}/>

							<Tab
								// className="setting-title-tab selected-tab"
								className=" setting-tabs-item"
								label="Financial"
								value="2"
								onClick={() => {
									history.push("/financial-setting");
								}}
								style={{width: "100px"}}
							/>
							<Tab className=" setting-tabs-item" label="Members" value="3" 
									onClick={() => {
										history.push("/financial-setting");
									}}
									style={{width: "100px"}}
							/>
							{isUserManagementActive ? <Tab className=" setting-tabs-item" label="Users & Permissions" value="5" style={{width: "190px"}}/> : <></>}
							<Tab className=" setting-tabs-item" label="Communications" value="6" style={{width: "160px"}}/>

							{(isPastoralEventsActive) ? <Tab className=" setting-tabs-item" label="Pastoral Events Type" value="4" style={{width: "190px"}}/> : <></>}

						</TabList>
					</Box>
					<SettingsRoutes isUserManagementActive={isUserManagementActive} value={value}/>
				</TabContext>
			</Box>
		</>
	);
}
